import type { Analytics, EventProperties, ID, UserTraits } from '@segment/analytics-next';
import { AnalyticsBrowser } from '@segment/analytics-next';
import type { History } from 'history';

type InitParams = {
  history: History;
};

class AnalyticsClient {
  private analytics: Analytics | undefined;

  private pageView = () => {
    void this.analytics?.page();
  };

  public init = ({ history }: InitParams) => {
    return AnalyticsBrowser.load({ writeKey: import.meta.env.VITE_APP_SEGMENT_KEY ?? '' })
      .then(([analytics]) => {
        this.analytics = analytics;

        // listen all url changes
        history.listen(this.pageView);
        // track current page
        this.pageView();
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error);
      });
  };

  public identify = (userId?: ID, traits?: UserTraits) => {
    void this.analytics?.identify(userId, traits);
  };

  public track = (type: string, props?: EventProperties) => {
    if (!import.meta.env.PROD) {
      // eslint-disable-next-line no-console
      console.log('analytics event:', type, props);
    }

    void this.analytics?.track(type, props);
  };
}

const client = new AnalyticsClient();

export default client;
